export default [
    {
      name:"parentLogin",  path:'/parent/', component: () => import('@/views/security')
    },
    {
        path:'/parent/createAccount', component: () => import('@/views/security/createAccount')
    },
    {
        path:'/parent/forgetPassword', component: () => import('@/views/security/forgetPassword')
    },
    {
        path:'/parent/resendActivationCode', component: () => import('@/views/security/resendActivationCode')
    },
    {
        name:"adminLogin",   path:'/admin/', component: () => import('@/views/security')
    },
    {
        path:'/admin/createAccount', component: () => import('@/views/security/createAccount')
    },
    {
        path:'/admin/forgetPassword', component: () => import('@/views/security/forgetPassword')
    },
    {
        path:'/admin/resendActivationCode', component: () => import('@/views/security/resendActivationCode')
    },
]